export const EMISSION_POINT_EXPORT_ID = 'emission-point';

export const EMISSION_POINT_TITLE = 'Punto de Emisión';

export const LOCALIZED_PROPERTIES = {
  name: 'Nombre',
  rute: 'Ruta',
  company: 'Compañía',
  salesOffices: 'Oficina de Venta',
};
